import(/* webpackMode: "eager" */ "/home/turath2/turath-websites/turath-website-learn/ar-prod/app/auth/error.tsx");
